import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { recommendations } from '@/mocks/siteData';
import RecommendCard from '@/components/feature/RecommendCard';
import Breadcrumb from '@/components/feature/Breadcrumb';

export default function RecommendSpecial() {
  useEffect(() => {
    document.title = '善良的小姨子 - 相关推荐专题';
    const desc = document.querySelector('meta[name="description"]');
    if (desc) {
      desc.setAttribute(
        'content',
        '与《善良的小姨子》风格相近的家庭温情剧集推荐专题，从邻里群像到亲情和解，帮你把温暖延续下去。'
      );
    }
  }, []);

  return (
    <div className="w-full animate-fade-up">
      <section className="w-full bg-primary-900">
        <div className="w-full px-4 md:px-6 py-12 md:py-16">
          <div className="max-w-3xl">
            <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-500 text-primary-950 text-xs md:text-sm font-medium mb-5">
              <i className="ri-bookmark-3-line w-4 h-4 flex items-center justify-center"></i>
              相关推荐专题
            </span>
            <h1 className="font-heading font-bold text-background-50 text-3xl md:text-5xl leading-tight mb-4">
              看完《善良的小姨子》不过瘾？<br className="hidden sm:block" />这些剧同样好哭
            </h1>
            <p className="text-background-200 text-sm md:text-lg leading-relaxed">
              我们按照题材、情感基调与人物关系，精选了 6 部与《善良的小姨子》气质相近的影视作品。它们同样聚焦家庭、邻里与成长，用细腻的日常讲述人间的善意与温度。
            </p>
          </div>
        </div>
      </section>

      <div className="w-full px-4 md:px-6 py-8 md:py-12">
        <Breadcrumb items={[{ label: '推荐专题' }]} />

        <section className="mt-8">
          <div className="flex flex-wrap items-center gap-3 mb-6">
            <h2 className="font-heading font-bold text-foreground-950 text-2xl md:text-3xl">
              精选推荐片单
            </h2>
            <span className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-900 text-xs">
              共 {recommendations.length} 部
            </span>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {recommendations.map((item, idx) => (
              <RecommendCard key={item.id} item={item} index={idx} />
            ))}
          </div>
        </section>

        <section className="mt-12 bg-background-100 border border-background-200 rounded-lg p-6 md:p-8">
          <div className="flex items-center gap-3 mb-4">
            <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
            <h2 className="font-heading font-bold text-foreground-950 text-xl md:text-2xl">
              我们如何挑选
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            <div className="bg-background-50 border border-background-200 rounded-lg p-5">
              <span className="inline-flex w-11 h-11 items-center justify-center rounded-lg bg-accent-100 text-accent-700 mb-3">
                <i className="ri-emotion-happy-line text-xl"></i>
              </span>
              <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2">
                情感基调一致
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                以温暖、治愈、贴近生活的家庭情感为主线，看完会让人心里发暖。
              </p>
            </div>
            <div className="bg-background-50 border border-background-200 rounded-lg p-5">
              <span className="inline-flex w-11 h-11 items-center justify-center rounded-lg bg-primary-100 text-primary-700 mb-3">
                <i className="ri-group-line text-xl"></i>
              </span>
              <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2">
                人物关系相近
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                聚焦亲情、邻里与年轻人之间的相互扶持，人物真实、有代入感。
              </p>
            </div>
            <div className="bg-background-50 border border-background-200 rounded-lg p-5">
              <span className="inline-flex w-11 h-11 items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 mb-3">
                <i className="ri-pulse-line text-xl"></i>
              </span>
              <h3 className="font-heading font-semibold text-foreground-950 text-base mb-2">
                节奏舒缓耐看
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                不靠强冲突推动，靠日常细节积累情绪，适合慢慢追、慢慢品。
              </p>
            </div>
          </div>
        </section>

        <section className="mt-12 flex flex-col sm:flex-row items-center justify-between gap-5 bg-primary-50 border border-primary-100 rounded-lg p-6 md:p-8">
          <div>
            <h2 className="font-heading font-bold text-foreground-950 text-xl mb-2">
              还没看完本剧？
            </h2>
            <p className="text-sm text-foreground-600">
              回到剧情列表，按集数把《善良的小姨子》慢慢追完吧。
            </p>
          </div>
          <div className="flex items-center gap-3 flex-wrap">
            <Link
              to="/category/plot"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-list-2-line w-4 h-4 flex items-center justify-center"></i>
              查看全部剧集
            </Link>
            <Link
              to="/"
              className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-accent-400 hover:text-accent-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
              返回首页
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
}